import React from "react";
import PropTypes from "prop-types";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import useLogger from "../../util/Logger";
import "./PropertyOpenWorkOrder.css";

function PropertyOpenWorkOrder({ openWorkOrder }) {
  const logger = useLogger();
  const navigate = useNavigate();

  const { propertyId } = useParams();

  const clickWorkOrder = async () => {
    logger.debug(
      "PropertyOpenWorkOrder.clickWorkOrder",
      `propertyId=${propertyId} closedWorkOrderId=${openWorkOrder?.id}`
    );
    navigate(`/property/${propertyId}/workorder/${openWorkOrder.id}`);
  };

  const getLatestWorkItem = () =>
    openWorkOrder.workItems.reduce(
      (latest, current) =>
        Number(latest.reference) > Number(current.reference) ? latest : current,
      { workitemtemplatedisplayname: "", reference: "0" }
    );

  const isNewSite =
    getLatestWorkItem().workitemtemplatedisplayname ===
    "Project - Property (New Site)";

  return (
    <tr
      className={`property-search-result ${isNewSite ? "disabled-row" : ""}`}
      onClick={isNewSite ? null : clickWorkOrder}
    >
      <td style={isNewSite ? { color: "grey" } : {}}>
        {openWorkOrder.reference}
      </td>
      <td style={isNewSite ? { color: "grey" } : {}}>
        {openWorkOrder.createdOn
          ? moment(openWorkOrder.createdOn).format("DD/MM/YYYY h:mm a")
          : ""}
      </td>
      <td style={isNewSite ? { color: "grey" } : {}}>{openWorkOrder.type}</td>
      <td style={isNewSite ? { color: "grey" } : {}}>
        {openWorkOrder.category}
      </td>
      <td style={isNewSite ? { color: "grey" } : {}}>
        {openWorkOrder.subCategory}
      </td>
      <td style={isNewSite ? { color: "grey" } : {}}>{openWorkOrder.status}</td>
      <td style={isNewSite ? { color: "grey" } : {}}>
        {getLatestWorkItem().workitemtemplatedisplayname}
      </td>
    </tr>
  );
}

PropertyOpenWorkOrder.propTypes = {
  openWorkOrder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    reference: PropTypes.string.isRequired,
    createdOn: PropTypes.string,
    type: PropTypes.string,
    category: PropTypes.string,
    subCategory: PropTypes.string,
    status: PropTypes.string,
    workItems: PropTypes.arrayOf(
      PropTypes.shape({
        reference: PropTypes.string.isRequired,
        workitemtemplatedisplayname: PropTypes.string,
      })
    ).isRequired,
  }).isRequired,
};

export default PropertyOpenWorkOrder;
